import React from "react"
import ContentLoader from "react-content-loader";

const TimelineSkeleton = (props) => {
    return(
        <ContentLoader viewBox="0 0 98% 31" height={51} width={'98%'} {...props}>
        <rect height="7" rx="1" ry="1" width="95%" x="31" y="30" />
        <circle cx="108" cy="30" r="7" />
        <circle cx="388" cy="30" r="7" />
        <circle cx="588" cy="30" r="7" />

        <rect x="168" y="237" rx="3" ry="3" width="298" height="329" />
       
       

        </ContentLoader>
    )
}
TimelineSkeleton.metadata = {
    filename: 'TimelineSkeleton',
  }
export default TimelineSkeleton